import React, { useMemo } from "react";
import styles from "./BoxSelector.module.css";
import { IconComponent } from "../icon-component";
import { CustomTooltip } from "../tooltip";

const BoxSelector = ({
	className = "",
	icon = null,
	onClick,
	selected = false,
	subTitle = "",
	title = "",
	value = "",
}) => {
	const subTitleToRender = useMemo(() => {
		if (subTitle) {
			return subTitle;
		}
		return value;
	}, [subTitle, value]);
	const handleClick = () => {
		onClick(value);
	};
	return (
		<div
			className={`${styles.container} ${
				typeof onClick === "function" && !selected ? styles["container--clickable"] : ""
			} ${className}`}
			data-selected={selected}
			role="presentation"
			onClick={handleClick}
		>
			{icon && <IconComponent color="var(--blue-500)" icon={icon} size="lg" />}
			<div className={styles.title}>{title}</div>
			<CustomTooltip showWhenOverflow title={subTitleToRender}>
				<div className={styles.value}>
					{subTitleToRender?.split("\n").map((s, index) => (
						<p key={s + index.toString()} className={styles.modalLine}>
							{s || <>&nbsp;</>}
						</p>
					))}
				</div>
			</CustomTooltip>
		</div>
	);
};

export default BoxSelector;
